export const getTotalHours = (
    durationInSeconds: number,
    formatNumber: (value: number | string) => string,
) => {
    if (!durationInSeconds || durationInSeconds === 0) return null;
    return interpolate(
        gettext('%(totalHours)s total hours'),
        {
            totalHours: formatNumber(Math.round((durationInSeconds / 3600) * 10) / 10),
        },
        true,
    );
};

export const loadInstructors = (instructors?: {name: string}[]) => {
    if (!instructors || !Array.isArray(instructors)) return [];
    return instructors.map((instructor) => ({
        display_name: instructor?.name,
    }));
};

export const loadOutcomes = (learningOutcomes?: string[]) => {
    if (!learningOutcomes || learningOutcomes.length === 0) return null;
    if (learningOutcomes.length > 3) return learningOutcomes.slice(0, 3);
    return learningOutcomes;
};
